import { useEffect } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { initRemoteFeatureFlags } from './initRemoteFeatureFlags'

export const useEnsureRemoteFeatureFlags = (): void => {
  const { isLoading, organization } = useUserOrganization()

  useEffect(() => {
    if (isLoading || !organization?.id) {
      return
    }

    initRemoteFeatureFlags({
      organizationId: organization.id,
      targetingKey: organization.id,
    })
  }, [isLoading, organization?.id])
}
